export const BI_WIDGET_NAME = 'wix-services-widget';
export const BI_WIDGET_ID = '800dace0-a9ea-4d19-a3d1-a6d536d3d6b5';
export const BI_SETTINGS_ACTIONS = {
  CLICK: 'click',
  CHANGE_TAB: 'change tab',
  SET_VALUE: 'set value',
  RESET_ALL: 'reset all',
};
export const BI_SETTINGS_COMPONENTS = {
  ADD_NEW_SERVICE: 'add-new-service',
  MANAGE_SERVICES: 'manage-services',
};
export const BI_INQUIRY_PAGE_NAME = 'inquiry services page';

export const NEW_SERVICES_PAGE_EXPERIMENT = 'specs.services.NewServicesPage';

export const ADDITIONAL_LAYOUTS_EXPERIMENT = 'wixServicesAdditionalLayouts';
